import React, { Suspense } from 'react';
import { Navigate } from "react-router-dom";

import LoadingSpinner from '@components/loading-spinner/LoadingSpinner';
import LazyLoadable from '@helpers/LazyLoadable';
import { lazy } from '@loadable/component';
import { ARCHEM_APPS } from '@src/app/pages/home/ArchemApps';
import ProtectedRoute from '@src/app/routes/ProtectedRoute';

const DashboardSummary = LazyLoadable(lazy(() => import("./dashboard/DashboardSummaryCard")))
const Reports = LazyLoadable(lazy(() => import("./reports/ReportsCard")))
const TradeSummaryCard = LazyLoadable(lazy(() => import('./summary/TradeSummaryCard')))
const ReoprtProductMapping = LazyLoadable(lazy(() => import('./report-product-mapping/ReportProductMapping')))

export const ROUTES_TRADE_SUMMARY = [
  {
    path: "/tradesummary",
    element: <Suspense fallback={<LoadingSpinner />}> <ProtectedRoute module_name={ARCHEM_APPS.TRADE_SUMMARY.module_name} /> </Suspense>,
    children: [
      {
        index: true,
        element: <Navigate to="dashboard" />,
      },
      {
        path: "dashboard",
        element: <DashboardSummary />
      },
      {
        path: "reports",
        element: <Reports />
      },
      {
        path: "summary",
        element: <TradeSummaryCard />,
      },
      {
        path: "maintenance/reportproductmapping",
        element: <ReoprtProductMapping />
      }
    ],
  },


];
